import React from 'react'
import { useTranslation } from 'react-i18next'
import categoryKeyMap from '../../lib/categoryKeyMap'

const CATEGORY_COLORS = {
  'Very Low': 'bg-red-100 text-red-700',
  'Moderately Low': 'bg-orange-100 text-orange-700',
  'Average': 'bg-gray-100 text-gray-700',
  'Moderately High': 'bg-blue-100 text-blue-700',
  'Very High': 'bg-green-100 text-green-700',
  'Below Average': 'bg-red-100 text-red-700',
  'Normal': 'bg-gray-100 text-gray-700',
  'Above Average': 'bg-green-100 text-green-700',
  'Extremely Low': 'bg-red-200 text-red-800',
  'Low': 'bg-orange-100 text-orange-700',
  'Moderate': 'bg-yellow-100 text-yellow-800',
  'High': 'bg-blue-100 text-blue-700',
  'Extremely High': 'bg-green-100 text-green-700',
}

function CategoryBadge({ category }) {
  const { t } = useTranslation('scoring')
  if (!category) return null
  const colors = CATEGORY_COLORS[category] || 'bg-gray-100 text-gray-600'
  const key = categoryKeyMap[category]
  const label = key ? t(key) : category
  return (
    <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-semibold ${colors}`}>
      {label}
    </span>
  )
}

export { CategoryBadge }

/**
 * Side-by-side score comparison for a single metric.
 */
export default function ScoreComparisonCard({ label, person1Value, person2Value, person1Category, person2Category, person1Name, person2Name }) {
  return (
    <div className="flex items-center justify-between py-2 border-b border-gray-50 last:border-0">
      <div className="text-sm text-gray-600 w-1/3 truncate" title={label}>{label}</div>
      <div className="flex items-center gap-2 w-1/3 justify-center">
        <span className="text-sm font-semibold text-gray-800">{person1Value}</span>
        {person1Category && <CategoryBadge category={person1Category} />}
      </div>
      <div className="flex items-center gap-2 w-1/3 justify-center">
        <span className="text-sm font-semibold text-gray-800">{person2Value}</span>
        {person2Category && <CategoryBadge category={person2Category} />}
      </div>
    </div>
  )
}

/**
 * Header row for comparison tables.
 */
export function ComparisonHeader({ person1Name, person2Name }) {
  const { t } = useTranslation('report')
  return (
    <div className="flex items-center justify-between pb-2 mb-2 border-b-2 border-gray-200">
      <div className="text-xs font-semibold text-gray-400 uppercase tracking-wider w-1/3">{t('quantitativeScores.metric')}</div>
      <div className="text-xs font-semibold text-gray-400 uppercase tracking-wider w-1/3 text-center">{person1Name}</div>
      <div className="text-xs font-semibold text-gray-400 uppercase tracking-wider w-1/3 text-center">{person2Name}</div>
    </div>
  )
}
